module.exports = __webpack_public_path__ + "img/print-label-pending.ea825e07.svg";